<template>
    <div class="footer-container">
      <div class="row-column" v-if="this.$route.path!='/ContactUs'">
        <h1>{{$t('footer.letStarted')}}</h1>
        <router-link class="btn" to="/ContactUs">{{$t('common.contactUs')}}</router-link>
      </div>
      <nav class="footer-nav">
        <div class="logo">
          <img src="../../assets/images/MPT Solution_logo_blue.svg" alt="">
        </div>
        <div class="footer-nav-box">
           <div class="footer-nav-list" >
            <ul class="footer-nav-list-item" v-for="(item,index) in routes()" v-if="!item.hideMenu">
              <li v-if="$i18n.locale=='EN'">{{item.name}}</li>
              <li v-if="$i18n.locale=='CN'">{{item.namecn}}</li>
              <li v-if="$i18n.locale=='CHT'">{{item.namecht}}</li>
              <li v-if="$i18n.locale=='JP'">{{item.namejp}}</li>
              <li v-for="subItem in item.children">
                <router-link :to="subItem.path" v-if="$i18n.locale=='EN'">{{subItem.name}} </router-link>
                <router-link :to="subItem.path" v-if="$i18n.locale=='CN'">{{subItem.namecn}} </router-link>
                <router-link :to="subItem.path" v-if="$i18n.locale=='CHT'">{{subItem.namecht}} </router-link>
                <router-link :to="subItem.path" v-if="$i18n.locale=='JP'">{{subItem.namejp}} </router-link>
              </li>
            </ul>
          </div>
          <div class="send-form">
            <h1>{{$t('footer.signTitle')}}</h1>
            <div class="input-group">
              <input type="text" class="form-control" :placeholder="$t('footer.signPlaceholder')" v-model="email">
              <span class="input-group-btn" @click="sendEmail">
                <button class="btn-default" type="button">{{$t('footer.signBtn')}}</button>
              </span>
            </div>
            <p>{{$t('footer.signTips')}}</p>
          </div>
        </div>
      </nav>
      <div class="footer-infor">
        <div class="col-sm-6">
          <ul>
            <li>
              <router-link to="/PrivacyPolicy">{{$t('footer.privacyPolicy')}}</router-link>
            </li>
            <li>
              <router-link to="/CookiePolicy">{{$t('footer.cookiePolicy')}}</router-link>
            </li>
            <li>
              <router-link to="/TermsUse">{{$t('footer.termsOfUse')}}</router-link>
            </li>
          </ul>
        </div>
        <div class="col-sm-6">
          <p>{{$t('footer.copyright')}}</p>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        // imgHeight:"300px"
        email:"",
      }
    },
    created(){
      // window.addEventListener('resize',this.getImgHeight)
    },
    mounted(){
      // this.getImgHeight();
      this.routes();
    },
    methods: {
      routes() {
        return this.$router.options.routes
        console.log(routes)
      },
      sendEmail(){
          let emailRules = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); 
          if(this.email==""){
            return this.$message.warning(this.$t('footer.emailrRquired'))
          }else if(this.email!=""&& !emailRules.test(this.email)){
            return this.$message.warning(this.$t('footer.emailVaild'))
          }else{
            let opt = {
              "email":this.email,
              "site":'MPTK',
              "language":localStorage.getItem('lang')
            }
            this.$api.SendMailAddress.SendMailAddressInfor(opt).then(res=>{
                this.$message.success(this.$t('common.sendSuccess'))
                this.email = ""
                console.log(res.data.result)
            }).catch(
                (error) => {
                  this.$message.fail(this.$t('common.sendFail'))
                  console.log(error)
                }
            )
          }
      }
      // getImgHeight(){
      //   this.imgHeight = this.$refs.imgHeight.clientHeight + 'px'
      // }
    }
  }
</script>

<style scoped>
  .row-column{
    width:100%;
    background: rgba(9, 25, 50, .97);
    background-size: cover;
    overflow: hidden;
    padding: 5rem 0;
  }
   .row-column h1{
     font-size: 3.5rem;
     font-weight: 700;
     color:#fff;
     margin-bottom: 4rem;
     text-shadow: 2px 2px 4px rgba(0,0,0,.04);
   }
   .row-column .btn{
     margin:0 auto;
   }
   .row-column h1~button:hover{
     background:#D74B00;
   }
  @media (min-width: 1200px){
    .footer-nav{
      width:1200px;
      margin:0 auto;
    }
  }
  .footer-nav{
    width:100%;
    padding:4rem auto;
  }
  .footer-nav img{
    width: 6rem;
    display: block;
    margin:4rem;
    margin-left: 10rem;
  }
  .footer-nav-box{
    width: auto;
    overflow: hidden;
    padding: 0 10rem;
  }
  .send-form{
    width: 35%;
    float: left;
  }
  .send-form>h1{
    text-align: left;
    font-size:2rem ;
    color:#29aae1;
    font-weight: 700;
    margin-bottom: 3rem;
  }
  .form-control{
    color:#0b1c36;
    border-color:#888;
  }
  .form-control,.btn-default{
    border-radius: 0;
    font-size: 1.6rem;
    font-weight: 700;
    text-align: left;
    height:4rem;
    line-height: 4rem;
    box-shadow: none;
    border-right: 0;
  }
  .btn-default{
    line-height: initial;
    color:#fff;
    background:#29aae1;
    border:none;
    width: 10rem;
    text-align: center;
  }
  .send-form p{
    text-align: left;
    margin-top: 2rem;
    color:#0b1c36;
    font-size: 1.6rem;
    line-height: 1.5;
  }
  .footer-nav-list{
    width:65%;
    float: left;
  }
  .footer-nav-list-item{
    float:left;
    width:33.333333%;
    min-height:32rem;
  }
  .footer-nav-list-item>li{
    font-size: 1.6rem;
    margin-bottom: 2rem;
    text-align: left;
  }
  .footer-nav-list-item>li:first-child{
    font-size: 2rem;
    color:#29aae1;
    margin-bottom: 3rem;
    font-weight: 700;
  }
  .footer-nav-list-item>li>a{
    color:#0b1c36;
    text-decoration: none;
  }
  .footer-infor{
    background:#0b1c36;
    height:7rem;
    overflow: hidden;
    padding:0 4rem;
    width:auto;
  }
  .footer-infor ul{
    margin-left: 5rem;
  }
  .footer-infor ul li{
    width:33.33333%;
    list-style: none;
    float:left;
    color:#fff;
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 7rem;
    text-align: left;
  }
  .footer-infor ul li a{
    color: #fff;
  }
  .footer-infor p{
    color:#fff;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 7rem;
  }
  @media (max-width: 767px){
    .row-column{
      padding:2rem 0;
    }
    .row-column h1{
      font-size: 1.2rem;
      margin-bottom: 2rem;
    }
    .footer-nav-list-item>li:first-child{
      margin-bottom: 1.5rem;
      font-size: 1rem;
    }
    .footer-nav-list-item>li{
      font-size: 0.7rem;
      text-align: center;
      margin-bottom: 1rem;
    }
    .footer-nav-list-item{
      min-height:12rem;
      width: 50%;
    }
    .footer-nav img{
      margin:2rem auto;
    }
    .footer-nav-box{
      padding:0;
    }
    .footer-nav-list{
      float:initial;
      width: auto;
      overflow: hidden;
    }
    .send-form{
      float:initial;
      width:auto;
      padding:0 2rem;
      margin-bottom: 1.5rem;
    }
    .send-form h1{
      text-align: center;
      font-size: 1rem;
      margin-bottom: 1rem;
    }
    .form-control,.btn-default{
      height:2rem;
      line-height: 2rem;
      font-size: 0.8rem;
    }
    .btn-default{
      width:4rem;
    }
    .send-form p{
      font-size: 0.8rem;
      margin-top: 1rem;
    }
    .footer-infor{
      height: auto;
      padding:0 1rem;
    }
    .footer-infor ul,.footer-infor p{
      width:auto;
      float:initial;
      font-size: 0.7rem;
      margin:1rem 0;
    }
    .footer-infor ul{
      overflow: hidden;
      margin-top: 1rem;
    }
    .footer-infor ul li{
      text-align: center;
      line-height: 1.5;
      font-size: 0.7rem;
    }
    .footer-infor p{
      line-height: 1.5;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Footer/Footer.vue